module.exports = __webpack_public_path__ + "img/zlz.b6259f7d.png";